export default __webpack_public_path__ + "static/media/skippedmeal_2.b65c6698.jpg";